module.exports = __webpack_public_path__ + "img/SWP_Axe_2H_02 (1).c792107e.png";